export default "__VITE_ASSET__C08YxfH$__"